import React from 'react';
import TextField from 'material-ui/TextField';
import NumberField from '../../../Base/NumberField';

class Tonnage extends React.Component {
    render() {
        const { confirmed, getError, changeField, modifiedFields, underStyle } = this.props;
        const { gt, nt, panamaGt, panamaNt, suezGt, suezNt } = this.props.rt;

        return (
            <React.Fragment>
                <div className='row'>
                    <div className='col-xs-6'>
                        <NumberField
                            name='GT'
                            floatingLabelText='GT'
                            value={gt || ''}
                            floatNumber
                            disabled={confirmed}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'rt.gt',
                                    value,
                                });
                            }}
                            errorText={getError('GT')}
                            fullWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('rt.gt') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-6'>
                        <NumberField
                            name='NT'
                            floatingLabelText='NT'
                            value={nt || ''}
                            floatNumber
                            disabled={confirmed}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'rt.nt',
                                    value,
                                });
                            }}
                            errorText={getError('NT')}
                            fullWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('rt.nt') ? underStyle : null}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-6'>
                        <NumberField
                            name='suezGT'
                            floatingLabelText='Suez GT'
                            value={suezGt || ''}
                            floatNumber
                            disabled={confirmed}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'rt.suezGt',
                                    value,
                                });
                            }}
                            errorText={getError('suezGT')}
                            fullWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('rt.suezGt') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-6'>
                        <NumberField
                            name='suezNT'
                            floatingLabelText='Suez NT'
                            value={suezNt || ''}
                            floatNumber
                            disabled={confirmed}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'rt.suezNt',
                                    value,
                                });
                            }}
                            errorText={getError('suezNT')}
                            fullWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('rt.suezNt') ? underStyle : null}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-6'>
                        <NumberField
                            name='panamaGT'
                            floatingLabelText='Panama GT'
                            value={panamaGt || ''}
                            floatNumber
                            disabled={confirmed}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'rt.panamaGt',
                                    value,
                                });
                            }}
                            errorText={getError('panamaGT')}
                            fullWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('rt.panamaGt') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-6'>
                        <NumberField
                            name='panamaNT'
                            floatingLabelText='Panama NT'
                            value={panamaNt || ''}
                            floatNumber
                            disabled={confirmed}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'rt.panamaNt',
                                    value,
                                });
                            }}
                            errorText={getError('panamaNT')}
                            fullWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('rt.panamaNt') ? underStyle : null}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Tonnage;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Tonnage.jsx